module.exports = __webpack_public_path__ + "img/chevron-right-tuktuk.2ade7779.svg";